import useLatest from "@utilityjs/use-get-latest";
import * as React from "react";
var isOptionParamSupported = function () {
    var optionSupported = false;
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    var fn = function () { };
    try {
        var opt = Object.defineProperty({}, "passive", {
            get: function () {
                optionSupported = true;
                return null;
            }
        });
        window.addEventListener("test", fn, opt);
        window.removeEventListener("test", fn, opt);
    }
    catch (e) {
        return false;
    }
    return optionSupported;
};
var useEventListener = function (config, shouldAttach) {
    if (shouldAttach === void 0) { shouldAttach = true; }
    var _a = config.target, target = _a === void 0 ? null : _a, eventType = config.eventType, handler = config.handler, options = config.options;
    var cachedOptions = useLatest(options);
    var cachedHandler = useLatest(handler);
    React.useEffect(function () {
        var _a;
        var element = target && "current" in target ? target.current : target;
        if (!element)
            return;
        var unsubscribed = false;
        var listener = function (event) {
            if (unsubscribed)
                return;
            cachedHandler.current(event);
        };
        var thirdParam = cachedOptions.current;
        if (typeof cachedOptions.current !== "boolean") {
            if (isOptionParamSupported())
                thirdParam = cachedOptions.current;
            else
                thirdParam = (_a = cachedOptions.current) === null || _a === void 0 ? void 0 : _a.capture;
        }
        shouldAttach && element.addEventListener(eventType, listener, thirdParam);
        return function () {
            unsubscribed = true;
            element.removeEventListener(eventType, listener, thirdParam);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [target, eventType, shouldAttach]);
};
export default useEventListener;
